import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/pages/home/Index.vue";
import ArticleList from "../components/pages/articles/List.vue";
import ArticleItem from "../components/pages/articles/Item.vue";
import VideoList from "../components/pages/videos/List.vue";
import VideoItem from "../components/pages/videos/Item.vue";
import Magazine from "../components/pages/magazine/List.vue";
// import EventList from "../components/pages/events/List.vue";
// import EventItem from "../components/pages/events/Item.vue";
import Contact from "../components/pages/Contact.vue";
import Error404 from "../components/pages/Error404.vue";
import PolicyPrivacy from "../components/pages/PolicyPrivacy.vue";
// import UnderConstruction from "../components/pages/UnderConstruction.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Início",
    component: Home,
  },
  {
    path: "/noticias",
    name: "Notícias",
    component: ArticleList,
  },
  {
    path: "/noticias/:category",
    name: "Notícias",
    component: ArticleList,
  },
  {
    path: "/noticias/:category/:item",
    name: "Notícia",
    component: ArticleItem,
  },
  {
    path: "/videos",
    name: "Vídeos",
    component: VideoList,
  },
  {
    path: "/videos/:item",
    name: "Vídeo",
    component: VideoItem,
  },
  // {
  //   path: "/agenda",
  //   name: "Agenda",
  //   component: EventList,
  // },
  // {
  //   path: "/agenda/:item",
  //   name: "Evento",
  //   component: EventItem,
  // },
  {
    path: "/revista",
    name: "Revista",
    component: Magazine,
  },
  {
    path: "/contato",
    name: "Contato",
    component: Contact,
  },
  // {
  //   path: "/agenda/:item",
  //   name: "Evento",
  //   component: EventItem,
  // },
  {
    path: "/error404",
    name: "Erro 404",
    component: Error404,
  },
  {
    path: "/politica-de-privacidade",
    name: "Política de Privacidade",
    component: PolicyPrivacy,
  },
  {
    path: "*",
    beforeEnter: (to, from, next) => {
      next("/error404");
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
